import { useMutation, useQueryClient } from '@tanstack/react-query'
import { unblockKemCard } from '../walletServices'

export const useUnblockKemCard = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: unblockKemCard,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['kem-card-details'] })
      queryClient.invalidateQueries({ queryKey: ['wallet'] })
    },
  })
}
